export class GetNotificationTokenCountRequest {
    channelCode?: string;
}
